export default __webpack_public_path__ + "static/media/1267.26a1383d.png";